import { BitkitEmptyState, BitkitLink, IconArrowNortheast, IconImage } from '@bitrise/bitkit-v2';

const AttachmentsEmptyState = () => {
  return (
    <BitkitEmptyState
      icon={IconImage}
      headingText="No attachments were found for this test case"
      bodyText="Missing screenshots or videos? Update the Deploy to Bitrise.io Step to the latest version."
    >
      <BitkitLink
        colorVariant="purple"
        href="https://docs.bitrise.io/en/bitrise-ci/testing/exporting-to-test-reports-from-any-step.html#exporting-screenshots-and-other-images-to-test-reports"
        isExternal
        suffixIcon={IconArrowNortheast}
        suffixIconSize="16"
      >
        Read the documentation
      </BitkitLink>
    </BitkitEmptyState>
  );
};

export default AttachmentsEmptyState;
